// src/features/text/components/TextStats.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TextStatsProps {
    stats: {
        words: number;
        characters: number;
        lines: number;
    };
}

const TextStats: React.FC<TextStatsProps> = ({ stats }) => {
    const { t } = useTranslation('tools');

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                gap: 2.5,
                py: 1,
                px: 1,
                color: 'text.secondary',
                userSelect: 'none', // Prevent text selection
            }}
        >
            <Typography variant="caption">
                {t('text_common_words')}: {stats.words}
            </Typography>
            <Typography variant="caption">
                {t('text_common_characters')}: {stats.characters}
            </Typography>
            <Typography variant="caption">
                {t('text_common_lines')}: {stats.lines}
            </Typography>
        </Box>
    );
};

export default TextStats;